import { useQuery } from "@tanstack/react-query";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { OpenapiSingleton } from "../../../utils/OpenapiSingleton";

export default function useAddressListQuery(trigger: boolean = true) {

  const { shopId, shopLangId } = useShop();

  const getAddresList = async () => {
    const response = await OpenapiSingleton.addressUserApi.addressBook(
      shopId,
      shopLangId,
    );
    return response;
  };

  return useQuery({
    queryKey: ["getAddresList"],
    queryFn: getAddresList,
    enabled: trigger
  });
}
